import { takeEvery } from 'redux-saga/effects';
import { getQcsSyncResources } from 'data/qcsSyncResourceSagaHelpers';
import { mkQcsSyncResourceConfig } from 'data/qcsSyncResourceTypes';

import { getLastSyncDate } from './investmentBalancesV2Selectors';
import { mkInvestmentBalanceV2 } from './investmentBalancesV2Types';
import * as actions from './investmentBalancesV2Actions';

export function* getInvestmentBalancesActionWatcher(): Generator<*, *, *> {
  const config = mkQcsSyncResourceConfig({
    resourceName: 'investment balances',
    resourceBaseUrl: '/v2/investments/balances',
    getLastSyncDate,
    successAction: actions.getInvestmentBalancesV2Success,
    failureAction: actions.getInvestmentBalancesV2Failure,
    transformResponseToResources: (response) => response.data && response.data.resources && response.data.resources.map((data) => mkInvestmentBalanceV2(data)),
  });
  yield takeEvery(actions.getInvestmentBalancesV2, getQcsSyncResources, config);
}

export default [
  getInvestmentBalancesActionWatcher,
];
